import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import { View } from "ui/atoms/view";
import { Button } from "ui/gluestack/button";
import { Text } from "react-native";
import { MedicationModel } from "app/services/api/types/medications/models/MedicationModel";
import React, { useImperativeHandle, useState } from "react";
import { useHandleMedication } from "../hooks/useHandleMedication";
import { useRouter } from "expo-router";

interface Ref {
  show: (initialMedication?: MedicationModel) => void;
}

const DeleteMedicationModal = React.forwardRef<Ref, unknown>(
  (_, discontinueRef) => {
    const [showing, setShowing] = useState(false);
    const [initialMedication, setInitialMedication] =
      useState<MedicationModel>();

    const router = useRouter();

    useImperativeHandle(discontinueRef, () => ({
      show: (initialMedication?: MedicationModel) => {
        setShowing(true);
        setInitialMedication(initialMedication);
      },
    }));

    const handleClose = () => {
      setShowing(false);
    };

    const { handleDeleteMedication, isLoadingAction } = useHandleMedication({
      initialMedication,
      onDeleteSuccess: () => {
        setShowing(false);
        router.replace(
          `/residents/${initialMedication?.resident_id}/medications`,
        );
      },
    });

    return (
      <ReusableModal
        isVisible={showing}
        onClose={handleClose}
        className="w-full max-w-[378px] mx-auto"
        title="Are you sure you want to discontinue this medication?"
        description="This action will remove this medication permanently and cannot be undone. Please confirm if you want to proceed."
        hasCancelButton
      >
        <View className="flex flex-row justify-end gap-x-4 ">
          <Button
            action="primary"
            size="sm"
            variant="outline"
            onPress={handleClose}
          >
            <Text className="text-primary-500 font-semibold">Cancel</Text>
          </Button>
          <Button
            action="negative"
            size="sm"
            disabled={isLoadingAction}
            onPress={() => {
              if (initialMedication) {
                setShowing(false);
                handleDeleteMedication({ id: initialMedication.id });
              }
            }}
          >
            <Text className="text-white">Discontinue</Text>
          </Button>
        </View>
      </ReusableModal>
    );
  },
);

DeleteMedicationModal.displayName = "DeleteMedicationModal";
export { DeleteMedicationModal };
